import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * App page title component with optional actions on the right.
 * Layout: title on the left, actions on the right.
 */ export function AppPageTitle(param) {
    let { title, children } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex justify-between items-center mb-3",
        children: [
            /*#__PURE__*/ _jsx("h1", {
                className: "text-lg font-semibold text-secondary-foreground m-0 flex items-center",
                "data-e2e": "PAGE_TITLE__".concat(title.toUpperCase().replace(' ', '_')),
                children: title
            }),
            children
        ]
    });
}
